// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"242":"33df90f654e5a73e0bbd","287":"5ab4b6326d4593757a21"}[chunkId] + ".css";
};